export default __webpack_public_path__ + "static/media/uploader-abbottNeo-3.c63b87c3.png";